import { formatDate } from "../services/format-date-filter";

class DateTimeMapper {
    public mapItem(input: string, language: string, format?: string): string {
        if (input) {
            var regex = /\d{4}-[01]\d-[0-3]\d/g;
            var matches = input.match(regex);

            if(matches) {
                var start = new Date(matches[0]);
                var end = new Date(matches[1]);
               
                if(matches.length == 1 || start.toDateString() === end.toDateString()) {
                    return formatDate(start, format, language);
                } else {
                    return `${formatDate(start, format, language)} - ${formatDate(end, format, language)}`;
                }
            }
        }

        return input;
    }
}

export default new DateTimeMapper();